(function ($) {
    var sportdataPage = $("html,body").first();

    var sportdataMultilevelMenuClass = {};
    sportdataMultilevelMenuClass.run = function (menuInstance) {
        // private variables
        var thisMenu = $(menuInstance);
        if (!thisMenu.hasClass("bfc-multilevel-menu")) {
            thisMenu = $(menuInstance).closest(".bfc-multilevel-menu");
        }

        // private methods
        var previousLevel = function () {
            var currentLevelIndex = getActiveLevelIndex();
            if (currentLevelIndex > 0) {
                thisMenu.find(".bfc-level.active").removeClass("active");
                thisMenu.find(".bfc-level").eq(currentLevelIndex - 1).addClass("active");
            }
            refreshBackButton();
        };
        var select = function (element) {
            if (isLastLevel(element) || isSingleLevel(element)) {
                thisMenu.trigger("bfcselectchange", [element]);
            } else {
                thisMenu.trigger("bfcselectchange", [null]);
                var currentLevelIndex = parseInt($(element).closest(".bfc-level").attr("data-level"));
                var currentActiveLevelIndex = getActiveLevelIndex();
                if (currentLevelIndex < currentActiveLevelIndex) {
                    thisMenu.find(".bfc-level[data-level=" + currentLevelIndex + "]").addClass("active", function () {
                        thisMenu.find(".bfc-level[data-level=" + currentLevelIndex + "]").removeClass("active");
                    });
                } else {
                    thisMenu.find(".bfc-level.active").removeClass("active");
                }
                thisMenu.find(".bfc-level").each(function () {
                    if (parseInt($(this).attr("data-level")) > currentLevelIndex) {
                        $(this).find("li").removeClass("selected");
                    }
                });
                var currentLevelID = element.data('id');
                var nextLevelIndex = currentLevelIndex + 1;
                var nextLevel = thisMenu.find(".bfc-level[data-level=" + nextLevelIndex + "]");
                nextLevel.find("li a:not(.bfc-add-new):not(.bfc-edit)").each(function () {
                    if ($(this).attr("data-parent-id") == currentLevelID) {
                        $(this).parent().removeClass("hide");
                    } else {
                        $(this).parent().addClass("hide");
                    }
                });
                thisMenu.find(".bfc-panel.active").stop(true).removeClass("active");
                var currentPanel = thisMenu.find(".bfc-panel .bfc-panel-wrapper[data-parent-id=" + currentLevelID + "]").closest(".bfc-panel");
                if (currentPanel.length > 0) {
                    currentPanel.addClass("active");
                    thisMenu.attr("data-last-panel", currentPanel.data('panel'));
                }
                nextLevel.addClass("active");
            }
            var thisLi = $(element).closest("li");
            if (!thisLi.hasClass("selected")) {
                thisLi.closest(".bfc-level").find("li.selected").removeClass("selected");
                thisLi.addClass("selected");
            }
            refreshBackButton();
            hideEmptyLevels();
        };
        var getActiveLevelIndex = function () {
            return parseInt(thisMenu.find(".bfc-level.active").attr("data-level"));
        };
        var isLastLevel = function (element) {
            return parseInt($(element).closest(".bfc-level").attr("data-level")) == thisMenu.find(".bfc-level").length - 1;
        };
        var isSingleLevel = function (element) {
            var allowChildren = $(element).attr("data-allow-children");
            if (allowChildren === "allow") {
                return false;
            } else {
                return parseInt(thisMenu.find(".bfc-level a[data-parent-id=" + $(element).attr("data-id") + "]").length) === 0;
            }
        };
        var refreshBackButton = function () {
            if (getActiveLevelIndex() > 0) {
                thisMenu.find(".bfc-back").removeClass("hide");
            } else {
                thisMenu.find(".bfc-back").addClass("hide");
            }
        };
        var resetLatestActivePanel = function (element) {
            var currentActiveLevelIndex = getActiveLevelIndex();
            var lastPanel = thisMenu.find(".bfc-panel[data-panel=" + thisMenu.attr("data-last-panel") + "]");
            var elementContainedInActiveLevel = element.within(thisMenu.find(".bfc-level.active"));
            if (elementContainedInActiveLevel.length === 0) {
                thisMenu.find(".bfc-level").stop(true);
                previousLevel();
                if (lastPanel.length > 0 && lastPanel.hasClass("active") === false) {
                    lastPanel.addClass("active");
                }
            }
        };
        var hideEmptyLevels = function () {
            thisMenu.find(".bfc-level.active").each(function () {
                var hiddenItemsCount = $(this).find("ul li.hide").length;
                var allItemsCount = $(this).find("ul li").length;
                if (hiddenItemsCount === allItemsCount) {
                    $(this).addClass("hide");
                } else {
                    $(this).removeClass("hide");
                }
            });
        };

        // public API
        return {
            previousLevel: previousLevel,
            select: select,
            refreshBackButton: refreshBackButton,
            resetLatestActivePanel: resetLatestActivePanel,
        };
    };

    var menuHoverTimer = null;
    var menuHoverTimerDelay = 1;

    $(document).ready(function () {
        var menus = $(".bfc-multilevel-menu");
        if (menus.length > 0) {
            menus.each(function () {
                var multilevelMenu = new sportdataMultilevelMenuClass.run($(this));
                multilevelMenu.refreshBackButton();
            });
        }
    });

    sportdataPage.on("click", ".bfc-multilevel-menu .bfc-back a", function (event) {
        event.stopPropagation();
        var multilevelMenu = new sportdataMultilevelMenuClass.run($(this));
        multilevelMenu.previousLevel();
    });

    sportdataPage.on("click", ".bfc-multilevel-menu .bfc-level ul li:not(.disabled) a:not(.bfc-add-new):not(.bfc-edit)", function (event) {
        if ($(this).data("has-children") == 1) {
            event.preventDefault();
        }
        event.stopPropagation();
        var multilevelMenu = new sportdataMultilevelMenuClass.run($(this));
        multilevelMenu.select($(this));
    });

    sportdataPage.on("mouseenter", ".bfc-multilevel-menu.bfc-autoselect .bfc-level ul li:not(.disabled) a:not(.bfc-add-new):not(.bfc-edit)", function (event) {
        event.stopPropagation();
        if (menuHoverTimer !== null) {
            clearTimeout(menuHoverTimer);
        }
        var currentAnchor = $(this);
        if (currentAnchor.attr("href") === "#!" || currentAnchor.data("has-children") == 1) {
            menuHoverTimer = setTimeout(function () {
                menuHoverTimerDelay = 300;
                var multilevelMenu = new sportdataMultilevelMenuClass.run(currentAnchor);
                multilevelMenu.select(currentAnchor);
            }, menuHoverTimerDelay);
        } else {
            menuHoverTimer = setTimeout(function () {
                menuHoverTimerDelay = 100;
                var multilevelMenu = new sportdataMultilevelMenuClass.run(currentAnchor);
                multilevelMenu.resetLatestActivePanel(currentAnchor);
            }, menuHoverTimerDelay);
        }
    });


    var sportdataMainMenuClass = {};
    sportdataMainMenuClass.run = function (menuInstance) {
        // private variables
        var thisMenu = $(menuInstance);
        if (!$(thisMenu).hasClass("bfc-main-menu")) {
            thisMenu = $(menuInstance).closest(".bfc-main-menu");
        }
        if (thisMenu.find(".bfc-background").length === 0) {
            thisMenu.prepend('<div class="bfc-background"></div>');
        }
        var currentTrigger = null;

        // private methods
        var open = function (trigger) {
            thisMenu.removeClass("mobile");
            thisMenu.find(".bfc-multilevel-menu").addClass("bfc-autoselect");
            currentTrigger = trigger;
            var selection = $(currentTrigger).attr("data-trigger");
            var currentSelection = $(thisMenu).find(".bfc-level a[data-id=" + selection + "]");
            if (currentSelection.length > 0) {
                selectElement(currentSelection);
            }
            thisMenu.addClass("open");
            currentTrigger.closest(".bfc-menu-triggers").find("a.bfc-selected").removeClass("bfc-selected");
            currentTrigger.addClass("bfc-selected");
            thisMenu.find(".bfc-background").stop(true).show("fade", 300);

        };
        var toggleOpenMobile = function () {
            thisMenu.addClass("mobile");
            if (thisMenu.hasClass("open")) {
                close();
            } else {
                thisMenu.find(".bfc-multilevel-menu").removeClass("bfc-autoselect");
                thisMenu.addClass("open");
                $(".bfc-background").stop(true).show("fade", 300);
                $(".bfc-panel").first().addClass("active");
            }
        };
        var close = function () {
            if (thisMenu.hasClass("open")) {
                thisMenu.removeClass("open");
                if (currentTrigger !== null) {
                    currentTrigger.removeClass("bfc-selected");
                }
                resetMenu();
                thisMenu.find(".bfc-background").stop(true).hide("fade", 300);
            }
        };
        var resetMenu = function () {
            thisMenu.find("li.selected").removeClass("selected");
            thisMenu.find(".bfc-level.active").removeClass("active");
            thisMenu.find(".bfc-level").first().addClass("active");
            var innerMenu = thisMenu.find(".bfc-multilevel-menu");
            if (innerMenu.length > 0) {
                innerMenu.each(function () {
                    var multilevelMenu = new sportdataMultilevelMenuClass.run(innerMenu);
                    multilevelMenu.refreshBackButton();
                });
            }
            menuTriggerHoverTimerDelay = 300;
        };
        var selectElement = function (currentSelection) {
            currentSelection.trigger("click");
        };
        var setPosition = function () {
            var navbar = $("header.site-header.sticky-top").first();
            if (navbar.length === 1) {
                thisMenu.css({
                    "top": (navbar.offset().top + navbar.outerHeight() - $(window).scrollTop()) + "px",
                    "left": navbar.offset().left + "px",
                    "width": navbar.outerWidth() + "px"
                });
            }
        };

        // public API
        return {
            setPosition: setPosition,
            open: open,
            toggleOpenMobile: toggleOpenMobile,
            close: close
        };
    };

    var menuTriggerHoverTimer = null;
    var menuTriggerHoverTimerDelay = 700;
    var menuPositioningTimer = null;
    var sportdataMainMenu = new sportdataMainMenuClass.run($(".bfc-main-menu:not(.mobile)").first());

    sportdataPage.on("mouseenter click", ".bfc-main-menu-trigger", function (event) {
        event.stopPropagation();
        var currentAnchor = $(this);
        menuTriggerHoverTimer = setTimeout(function () {
            menuTriggerHoverTimerDelay = 200;
            sportdataMainMenu.open(currentAnchor);
        }, menuTriggerHoverTimerDelay);
    }).on("mouseleave", ".bfc-main-menu-trigger", function (event) {
        event.stopPropagation();
        if (menuTriggerHoverTimer !== null) {
            clearTimeout(menuTriggerHoverTimer);
        }
    }).on("mouseleave", ".bfc-main-menu:not(.mobile) .bfc-multilevel-menu", function (event) {
        var newTarget = event.toElement || event.relatedTarget;
        if (!$(newTarget).hasClass("bfc-main-menu-trigger") && !$(newTarget).hasClass("main-navigation") && !$(newTarget).hasClass("sportdata-secondary-navigation") && !$(newTarget).within(".sportdata-secondary-navigation")) {
            sportdataMainMenu.close();
        }
    });

    sportdataPage.on("click", ":not(.bfc-main-menu .bfc-multilevel-menu):not(.bfc-main-menu .bfc-multilevel-menu *):not(.bfc-main-menu-trigger):not(.bfc-mobile-menu-trigger), .sportdata-search-panel-trigger", function (event) {
        sportdataMainMenu.close();
    });

    $(".sportdata-search-panel-trigger").on("click", function (event) {
        sportdataMainMenu.close();
    });

    $(".bfc-mobile-menu-trigger").on("click", function (event) {
        event.stopPropagation();
        var currentAnchor = $(this);
        sportdataMainMenu.toggleOpenMobile();
    });
    $(window).resize(function () {
        if (menuPositioningTimer !== null) {
            clearTimeout(menuPositioningTimer);
        }
        menuPositioningTimer = setTimeout(function () {
            sportdataMainMenu.setPosition();
        }, 300);
    }).resize();
    $(window).scroll(function () {
        if (menuPositioningTimer !== null) {
            clearTimeout(menuPositioningTimer);
        }
        menuPositioningTimer = setTimeout(function () {
            sportdataMainMenu.close();
            sportdataMainMenu.setPosition();
        }, 10);
    });

    //https://github.com/wp-bootstrap/wp-bootstrap-navwalker/issues/391#issuecomment-443449007
    // dropdown multilevel
    $('.dropdown-menu > li > .dropdown-menu').parent().addClass('dropdown-submenu').find(' > .dropdown-item').attr('href', 'javascript:;').addClass('dropdown-toggle');
    $('.dropdown-submenu > a').on("click", function (e) {
        var dropdown = $(this).parent().find(' > .show');
        $('.dropdown-submenu .dropdown-menu').not(dropdown).removeClass('show');
        $(this).next('.dropdown-menu').toggleClass('show');
        e.stopPropagation();
    });

    // hide all open menus if the parent closes
    $('.dropdown').on("hidden.bs.dropdown", function () {
        $('.dropdown-menu.show').removeClass('show');
    });

})(jQuery);
